import { useTranslation } from 'react-i18next'

export default function About() {
  const { t } = useTranslation()

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow">Almus</p>
        <h1 className="section-title">{t('about.title')}</h1>
        <p className="section-sub">{t('about.intro')}</p>

        <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 56 }}>{t('about.mission')}</h2>
        <p className="section-sub">{t('mission.text')}</p>

        <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 48 }}>{t('about.values')}</h2>
        <ul className="check-list" style={{ marginTop: 20 }}>
          {t('mission.values', { returnObjects: true }).map((v) => (
            <li key={v}>{v}</li>
          ))}
        </ul>

        <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 48 }}>{t('about.team')}</h2>
        <div className="team-note">
          {t('about.teamText')}
        </div>
      </div>
    </section>
  )
}